export const API_ROOT_URL = process.env.REACT_APP_API_BASE_URL;

//login
export const LOGIN_API = '/users/api/v3/login/';
export const GOOGLE_LOGIN_API = '/users/api/v3/login/social/';
export const CARROUSEL_API = '/users/api/v3/images-carrousel/';
export const REGISTER_API = '/users/api/v3/register/';
export const VERIFY_OTP_API = '/users/api/v3/verify-email-otp/';
export const RESEND_EMAIL_API = '/users/api/v3/resend-email-for-verification/';
export const FORGOT_API = '/users/api/v3/forgot-password/';
export const PROFESSION_API = '/users/api/v3/profession/';
export const INDUSTRY_API = '/users/api/v3/industry/';
export const PLATFORM_API = '/users/api/v3/usecase/';
export const TERMS_API = '/tnc/latest/';
export const USER_PREFERENCE_API = '/users/api/v3/user-preferences/';
export const ACCOUNT_STATUS_API = '/users/api/v3/check-account-status/';
export const LINK_VERIFY_API = '/users/api/v3/verify-email-with-link/';
export const CREATE_PASSWORD_API = '/users/api/v3/reset-password-confirmation/';
export const UPDATE_USER_PROFILE_API = '/users/api/v3/user-details/';
export const GET_ACCESS_REFRESH_TOKEN = '/users/api/v3/login/refresh/';
export const GLOBAL_SEARCH_API = '/organization/api/v3/search-api/';
export const TUTORIAL_API = '/users/api/v3/tutorial/';

//curator
export const ROOM_LAYOUT_API = '/rooms/api/v3/layout-detail/';
export const PROPS_API = '/assetbundles/api/v3/products/detail/';
export const MATTRESS_PROPS_API = '/assetbundles/api/v3/products/detail/mattress-builder/';
export const ROOM_DETAILS_API = '/rooms/api/v3/room-detail/';
export const ONBOARDING_ROOM_DETAILS_API = '/gamify/api/tutorial-room-detail/';
export const ROOM_TYPE_API = '/rooms/api/v3/room-type/';
export const CREATE_ROOM = '/rooms/api/v3/room-detail/';
export const TEXTURE_DETAILS_API = '/texture/api/v3/texture/detail/v2/';
export const GET_SETTING_API = '/users/api/v3/get-user-curator-settings/';
export const EDIT_SETTING_API = '/users/api/v3/user-curator-settings-detail/';
export const CREATE_SETTINGS_API = '/users/api/v3/user-curator-settings-detail/';
export const GET_DEFAULT_METADATA = '/users/api/v3/default-meta-data-detail/';
export const LIGHT_API = '/organization/api/v3/environment-light-detail/';

export const PROP_GROUP_API = '/assetbundles/api/v3/prop-group/products/detail/';
export const PROP_GROUP_API_V2 = '/assetbundles/api/v3/retail-prop-group/products/detail/';
export const PROP_GROUP_OVERWRITE_API = '/assetbundles/api/v3/prop-group/overwrite/:groupId/';
export const PRODUCT_GROUP_FOR_NORMAL_USER_API =
  '/assetbundles/api/v3/client-prop-group/products/detail/';
export const GET_GROUP_PROP_LIST_API = '/assetbundles/api/v3/get-prop-list-based-on-main-prop/';

export const ORGANISATION_DETAILS_API = '/organization/api/v3/get-all-organization/';

//projects
export const GET_PROJECT_API = '/organization/api/v3/projects/details/';
export const GET_ROOMS_API = '/rooms/api/v3/room-detail/';
export const GET_PROPS_API = '/assetbundles/api/v3/products/detail/';
export const PROJECT_UPDATE = '/organization/api/v3/projects/details/:projectId/';

// configurator
export const GET_CONFIGURATOR_API = '/configurator/api/config/';
export const GET_CONFIGURATOR_API_V2 = '/configurator/api/v2/config/';
export const DUPLICATE_CONFIGURATOR_API = '/configurator/api/configurator-duplicate/';
export const DUPLICATE_CONFIGURATOR_API_V2 = '/configurator/api/v2/configurator-duplicate/';
export const CREATE_CONFIGURATOR_SCENE_API = '/configurator/api/config-scene/';
export const CREATE_CONFIGURATOR_SCENE_API_V2 = '/configurator/api/v2/config-scene/';
export const DUPLICATE_CONFIGURATOR_SCENE_API = '/configurator/api/scene-duplicate/';
export const DUPLICATE_CONFIGURATOR_SCENE_API_V2 = '/configurator/api/v2/scene-duplicate/';
export const REORDER_CONFIGURATOR_SCENE_API = '/configurator/api/multiple-scene-seq-update/';
export const REORDER_CONFIGURATOR_SCENE_API_V2 = '/configurator/api/v2/multiple-scene-seq-update/';
export const GET_CONFIGURATOR_SCENE_LIST_API = '/configurator/api/config-scene/';
export const GET_CONFIGURATOR_SCENE_LIST_API_V2 = '/configurator/api/v2/config-scene/';
export const UPDATE_CONFIGURATOR_SCENE_API = '/configurator/api/scene/details/:sceneId/';
export const UPDATE_CONFIGURATOR_SCENE_API_V2 = '/configurator/api/v2/scene/details/:sceneId/';
export const GET_CONFIGURATOR_VIEW_LIST_API = '/configurator/api/scene-view/';
export const GET_CONFIGURATOR_VIEW_LIST_API_V2 = '/configurator/api/v2/scene-view/';
export const CREATE_CONFIGURATOR_VIEW_API = '/configurator/api/scene-view/?scene=:sceneId';
export const CREATE_CONFIGURATOR_VIEW_API_V2 = '/configurator/api/v2/scene-view/?scene=:sceneId';
export const UPDATE_CONFIGURATOR_VIEW_API = '/configurator/api/scene-view/:viewId/';
export const UPDATE_CONFIGURATOR_VIEW_API_V2 = '/configurator/api/v2/scene-view/:viewId/';
export const DELETE_CONFIGURATOR_VIEW_API = '/configurator/api/scene-view/:viewId/';
export const DELETE_CONFIGURATOR_VIEW_API_V2 = '/configurator/api/v2/scene-view/:viewId/';
export const GET_CONFIGURATOR_LIGHTING_API = '/configurator/api/configurator-lightroom/';
export const GET_CONFIGURATOR_LIGHTING_API_V2 = '/configurator/api/v2/configurator-lightroom/';
export const GET_CONFIGURATOR_CAMERA_PRESETS_API =
  '/configurator/api/scene-view-preset/config/:configuratorId/';
export const ADD_CONFIGURATOR_CAMERA_PRESETS_API =
  '/configurator/api/scene-view-preset/:configuratorId/';
export const UPDATE_CONFIGURATOR_CAMERA_PRESETS_API =
  '/configurator/api/scene-view-preset/:presetId/';
export const CREATE_CONFIGURATOR_LABEL = '/configurator/api/scene-option/';
export const CREATE_CONFIGURATOR_LABEL_V2 = '/configurator/api/v2/scene-option/';
export const UPDATE_CONFIGURATOR_LABELS_API = '/configurator/api/multiple-sceneoption-update/';
export const UPDATE_CONFIGURATOR_LABELS_API_V2 =
  '/configurator/api/v2/multiple-sceneoption-update/';
export const UPDATE_CONFIGURATOR_LABEL_API = '/configurator/api/scene-option/:labelId/';
export const UPDATE_CONFIGURATOR_LABEL_API_V2 = '/configurator/api/v2/scene-option/:labelId/';
export const SCENE_OPTION_DUPLICATE_API = '/configurator/api/scene-option-duplicate/';
export const SCENE_OPTION_DUPLICATE_API_V2 = '/configurator/api/v2/scene-option-duplicate/';
export const DELETE_CONFIGURATOR_LABEL_API = '/configurator/api/scene-option/:labelId/';
export const DELETE_CONFIGURATOR_LABEL_API_V2 = '/configurator/api/v2/scene-option/:labelId/';
export const GET_CONFIGURATOR_LABELS = '/configurator/api/scene-option/';
export const GET_CONFIGURATOR_LABELS_V2 = '/configurator/api/v2/scene-option/';
export const GET_CONFIGURATOR_BACKGROUND_LIST_API = '/configurator/api/view-background/';
export const GET_CONFIGURATOR_BACKGROUND_LIST_API_V2 = '/configurator/api/v2/view-background/';
export const UPDATE_CONFIGURATOR_BACKGROUND_API = '/configurator/api/view-background/:bgId/';
export const UPDATE_CONFIGURATOR_BACKGROUND_API_V2 = '/configurator/api/v2/view-background/:bgId/';
export const CREATE_LABEL_OPTIONS_API = '/configurator/api/multiple-scene-texture/';
export const CREATE_LABEL_OPTIONS_API_V2 = '/configurator/api/v2/multiple-scene-texture/';
export const UPDATE_LABEL_OPTIONS_API = '/configurator/api/multiple-scene-texture/';
export const UPDATE_LABEL_OPTIONS_API_V2 = '/configurator/api/v2/multiple-scene-texture/';
export const GET_LABEL_OPTIONS_API = '/configurator/api/scene-texture/';
export const GET_LABEL_OPTIONS_API_V2 = '/configurator/api/v2/scene-texture/';
export const UPDATE_LABEL_OPTION_API = '/configurator/api/scene-texture/:optionId/';
export const UPDATE_LABEL_OPTION_API_V2 = '/configurator/api/v2/scene-texture/:optionId/';
export const DELETE_LABEL_OPTIONS_API = '/configurator/api/multiple-scene-texture/';
export const DELETE_LABEL_OPTIONS_API_V2 = '/configurator/api/v2/multiple-scene-texture/';
export const UPLOAD_DEFAULT_TEXTURE_THUMBNAIL = '/configurator/api/multiple-scene-texture-upload/';
export const UPLOAD_DEFAULT_TEXTURE_THUMBNAIL_V2 =
  '/configurator/api/v2/multiple-scene-texture-upload/';
export const GET_LABEL_OPTIONS_WITH_TIME = '/configurator/api/render-status-data/';
export const GET_LABEL_OPTIONS_WITH_TIME_V2 = '/configurator/api/v2/render-status-data/';
export const TEXTURE_RE_RENDER = '/configurator/api/scene-texture-re-render/';
export const TEXTURE_RE_RENDER_V2 = '/configurator/api/v2/scene-texture-re-render/';
export const UPLOAD_IMAGES_CONFIGURATOR = '/configurator/api/configurator-all-presigned-data/';
export const UPLOAD_IMAGES_CONFIGURATOR_V2 =
  '/configurator/api/v2/configurator-all-presigned-data/';
export const UPLOAD_IMAGES = '/configurator/api/configurator-images-upload/';
export const UPLOAD_IMAGES_V2 = '/configurator/api/v2/configurator-images-upload/';
export const UPLOAD_SHADOW_IMAGES = '/configurator/api/shadow-images-upload/';
export const UPLOAD_SHADOW_IMAGES_V2 = '/configurator/api/v2/shadow-images-upload/';
export const DOWNLOAD_IMAGES = '/configurator/api/configurator-images-download/';
export const DOWNLOAD_IMAGES_V2 = '/configurator/api/v2/configurator-images-download/';
export const DOWNLOAD_SHADOW_IMAGES = '/configurator/api/configurator-shadow-images-download/';
export const DOWNLOAD_SHADOW_IMAGES_V2 = '/configurator/api/v2/shadow-images-download/';
export const GET_SCENE_PUBLIC_DATA = '/configurator/api/all-scene-public-data/';
export const GET_SCENE_PUBLIC_DATA_V2 = '/configurator/api/v2/all-scene-public-data/';
export const GET_SCENE_PRIVATE_DATA = '/configurator/api/all-scene-data/';
export const GET_SCENE_PRIVATE_DATA_V2 = '/configurator/api/v2/all-scene-data/';
export const GET_SCENE_LABEL_PUBLIC_API = '/configurator/api/sceneoption-public-data/';
export const GET_SCENE_LABEL_PUBLIC_API_V2 = '/configurator/api/v2/sceneoption-public-data/';
export const GET_LABEL_OPTIONS_PUBLIC_API = '/configurator/api/scenetexture-public-data/';
export const GET_LABEL_OPTIONS_PUBLIC_API_V2 = '/configurator/api/v2/scenetexture-public-data/';
export const GET_PROTOTYPE_PREVIEWS_API = '/configurator/api/update-scene-texture-render/';
export const GET_PROTOTYPE_PREVIEWS_API_V2 = '/configurator/api/v2/update-scene-texture-render/';
export const GET_SHADOW_IMAGES = '/configurator/api/get-shadow-images/';
export const GET_SHADOW_IMAGES_V2 = '/configurator/api/v2/get-shadow-images/';
export const GET_SHADOW_IMAGES_PUBLIC = '/configurator/api/get-shadow-images-public/';
export const GET_SHADOW_IMAGES_PUBLIC_V2 = '/configurator/api/v2/get-shadow-images-public/';
export const GET_SCENE_VIEWS_PROTOTYPE = '/configurator/api/scene-view-background-info/';
export const GET_SCENE_VIEWS_PROTOTYPE_V2 = '/configurator/api/v2/scene-view-background-info/';
export const GET_SCENE_VIEWS_PUBLIC_PROTOTYPE =
  '/configurator/api/scene-view-background-info-public/';
export const GET_SCENE_VIEWS_PUBLIC_PROTOTYPE_V2 =
  '/configurator/api/v2/scene-view-background-info-public/';
export const GET_SCENE_IDS_V2 = '/configurator/api/v2/get-scene-ids/';
export const GET_SCENE_IDS = '/configurator/api/get-scene-ids/';
export const GET_DEFAULT_TEXTURES_V2 = '/configurator/api/v2/get-default-textures/';
export const GET_DEFAULT_TEXTURES = '/configurator/api/get-default-textures/';
export const GET_SELECTED_TEXTURES_V2 = '/configurator/api/v2/get-selected-textures/';
export const GET_SELECTED_TEXTURES = '/configurator/api/get-selected-textures/';
export const GET_ALL_SCENE_TOKEN_V2 = '/configurator/api/v2/all-scene-token/';
export const GET_ALL_SCENE_TOKEN = '/configurator/api/all-scene-token/';
export const GET_CONFIGURATOR_ALL_MERGE = '/configurator/api/merge/v2/';
export const GET_CONFIGURATOR_SINGLE_MERGE = '/configurator/api/single-merge/v2/';
export const GET_CONFIGURATOR_ALL_MERGE_V2 = '/configurator/api/v2/merge/v2/';
export const GET_CONFIGURATOR_SINGLE_MERGE_V2 = '/configurator/api/v2/single-merge/v2/';
export const RENDER_STORE_KEYS_UPDATE_V2 = '/configurator/api/v2/render-store-keys-update/';
export const RENDER_STORE_KEYS_UPDATE = '/configurator/api/render-store-keys-update/';
export const GET_PUBLIC_PRODUCT_DATA = '/configurator/api/v2/v3/config-product-public-data/';
export const GET_TEXTURE_LINKING = '/configurator/api/v2/scene-texture-linking-get/';
export const GET_TEXTURE_LINKING_PUBLIC = '/configurator/api/v2/scene-texture-linking-get-public/';
export const UPDATE_TEXTURE_LINKING = '/configurator/api/v2/scene-texture-linking/';

// autosave
export const AUTOSAVE_API = '/organization/api/v3/projects/autosave/details/';

//teamsPage
export const GET_MEMBERS_API = '/organization/api/v3/members/details/';
export const GET_MEMBERS_API_V4 = '/organization/api/v3/members/details/v4/';
export const SEND_INVITE_API = '/organization/api/v3/send-invite/';
export const GET_PENDING_LIST = '/organization/api/v3/invitation-pendding-list/';
export const DELETE_PENDING_INVITATION = '/organization/api/v3/delete-invitation-pendding-list/';

//settings
export const GET_USER_DETAILS = '/users/api/v3/user-details/';

// favourite
export const ADD_FAVOURITE_PROJECTS = '/organization/api/v3/my-projects/details/';
export const ADD_FAVOURITE_ROOM = '/rooms/api/v3/room-detail/';

// delete
export const PROJECT_DELETE = '/organization/api/v3/projects/details/';
export const ROOM_DELETE = '/organization/api/v3/room-detail/';

// material
// texture
export const GET_MATERIAL = '/organization/api/v3/material/detail/';
export const MATERIAL_API = '/material/api/v3/material/detail/';
export const MATERIAL_COLOR_CODE_API = '/material/api/v3/material-color-code-detail/';

// texture
export const GET_TEXTURE = '/organization/api/v3/texture/detail/';
export const TEXTURE_API = '/texture/api/v3/texture/detail/v2/';
export const TEXTURE_BULK_UPLOAD = '/texture/api/v3/texture-buld-create/';
export const TEXTURE_BULK_UPDATE = '/texture/api/v3/texture/update/';
export const TEXTURE_BULK_DELETE = '/texture/api/v3/delete-textures/';
export const TEXTURE_DOWNLOAD = '/texture/api/v3/lambda/texture/download/';

// preset camera (curator)
export const PRESET_CAMERA_ANGLE = '/rooms/api/v3/render-camera-angle/';
export const PRESET_CAMERA_IMPORT = '/organization/api/v3/import_camera_angle/';
export const CAMERA_ANGLE_PRESET = '/organization/api/v3/camera-angle-preset/'
// export const GET_CAMERA_ANGLE = '/rooms/api/v3/render-camera-angle/'
// export const CREATE_CAMERA_ANGLE = '/rooms/api/v3/render-camera-angle/'
// export const UPDATE_CAMERA_ANGLE = '/rooms/api/v3/render-camera-angle/'
// export const DELETE_CAMERA_ANGLE = '/rooms/api/v3/render-camera-angle/'

// project camera (curator)
export const PROJECT_CAMERA_ANGLE = '/organization/api/v3/projects_camera_angle/details/';
export const GET_PROJECT_CAMERA_ANGLE = '/organization/api/v3/projects_camera_angle/details/';
export const CREATE_PROJECT_CAMERA_ANGLE = '/organization/api/v3/projects_camera_angle/details/';
export const UPDATE_PROJECT_CAMERA_ANGLE = '/organization/api/v3/projects_camera_angle/details/';
export const DELETE_PROJECT_CAMERA_ANGLE = '/organization/api/v3/projects_camera_angle/details/';

// images (curator) - render

// rendering-system/api/v3/images-render-detail/?parent_id=148
export const DOWNLOAD_RENDER = '/rendering-system/api/v3/lambda/download-renders/';
export const GET_RENDER_PREVIEW_DATA = '/rendering-system/api/v3/project-render-images/';
export const UPDATE_RENDER_PREVIEW = '/rendering-system/api/v3/project-render-images/';
// rendering-system/api/v3/images-render-detail/?parent_id=148
export const GET_CAMERA_INFO = '/rendering-system/api/v3/images-render-detail/';
export const CREATE_RENDER = '/rendering-system/api/v3/render-detail/';
export const DELETE_RENDER = '/rendering-system/api/v3/images-render-detail/';
export const DOWNLOAD_RENDER_IMAGE = '/rendering-system/api/v3/lambda/download-renders/';
// export const CREATE_RENDER = '/rendering-system/api/v3/render-detail/'
// export const CREATE_RENDER = '/rendering-system/api/v3/render-detail/'

// render & preview//
export const GET_RENDER_PREVIEW = '/rendering-system/api/v3/project-render-images/';
export const GET_DOWNLOAD_RENDER_IMAGES = '/rendering-system/api/v3/lambda/download-renders/';
export const GET_RENDER_DATA = '/rendering-system/api/v3/get-render/';
export const RENDER_PARTIAL_PAYMENT = '/rendering-system/api/v3/render-partial-payment-detail/';
export const UPDATE_PRODUCT_RENDER_JSON = '/rendering-system/api/v3/project-render-json-file/'

// Filters
export const GET_FILTERS = '/users/api/v3/filters/';
export const CREATE_FILTER_OPTION = '/users/api/v3/filters/';

export const GET_GLOBAL_TAGS = '/organization/api/v3/global-tags/';

// share
export const CREATE_SHARE = '/share/api/v3/sharingmodels/';

//Transaction
export const GET_USER_BALANCE = '/images/api/organization-balance/';
export const PAYMENT_INTENT = '/images/api/create-payment-intent/';
export const TRANSACTION_HISTORY = '/images/api/organization-transaction-history/';
export const CHANGE_PASSWORD = '/users/api/v3/change-password/';

//Notification Settings
export const NOTIFICATION_SETTINGS = '/notifications/settings/';

// collection
export const COLLECTION_DETAILS_API = '/organization/api/v3/collections/details/';

// organization
export const GET_MY_ORGANIZATIONS = '/organization/api/v3/my-orgs/';

// support
export const TICKETS_API = '/support/api/v3/raise-ticket/';

// automation
export const GET_AUTOMATION_API = '/image_automation/api/v2/list_automation/';
export const GET_AUTOMATION_DETAIl_API = '/image_automation/api/v2/automation-action-templates/';
export const DOWNLOAD_SAMPLE_EXCEL_API = `${API_ROOT_URL}/image_automation/api/v2/download-sample-excel-v2/`;
export const CREATE_AUTOMATION_PREVIEW_API = '/image_automation/api/v2/create-preview/';
export const ENABLE_AUTOMATION_RENDER_API = '/image_automation/api/v2/bulk-automation-render/';
export const GET_AUTOMATION_EXCELS_API = '/image_automation/api/v2/automation-all-action-files/';

export const SAVE_AS_TEMPLATE_CONFIGURATOR_API = '/configurator/api/configurator-template/';

export const DOWNLOAD_CONFIGURATOR_API = '/configurator/api/download-configurator/';
export const GET_CONFIGURATORS = '/three-sixty/api/v2/get-threesixty/';
export const GET_CONFIGURATORS_BASE_URL = process.env.REACT_APP_V1_URL;
export const CONFIGURATOR_URL = 'https://360.livefurnish.com/viewer/';
export const GET_CONFIGURATOR_THEMES = '/configurator/api/config-theme/';
export const GET_ALL_ASPECT_RATIO = '/configurator/api/get-aspect-ratio/';
export const GET_ALL_TEMPLATES = '/configurator/api/configurator-template/';
export const DUPLICATE_TEMPLATES = '/configurator/api/configurator-template-duplicate/';
export const GET_RENDER_STORE_LIST = '/configurator/api/get-render-store/';
export const REORDER_VIEWS = '/configurator/api/multiple-sceneview-seq-update/';
export const REORDER_VIEWS_V2 = '/configurator/api/v2/multiple-sceneview-seq-update/';
export const CONFIG_PUBLIC_LINK = '/configurator/api/config-public-link/';
export const CONFIG_PUBLIC_LINK_V2 = '/configurator/api/v2/config-public-link/';
export const CONFIG_PUBLIC_DATA = '/configurator/api/config-public-data/';
export const CONFIG_PUBLIC_DATA_V2 = '/configurator/api/v2/config-public-data/';
export const CONFIG_PUBLIC_DATA_V3 = '/configurator/api/v2/v3/config-public-data/';
export const DELETE_PREVIEWS = '/configurator/api/reset-preview-data/';
export const DELETE_PREVIEWS_V2 = '/configurator/api/v2/reset-preview-data/';
export const SET_SCENE_TEXTURE_SEQUENCE = '/configurator/api/v2/set-scenetexture-sequence/';

export const GET_TILEGROUT_PATTERN = '/texture/api/v3/patterns/';
export const GROUT_COLORS = '/texture/api/v3/get-grout-color/';
export const CREATE_PATTERN_TEXTURE = '/texture/api/v3/create-patterns-texture/';
export const CREATE_PATTERN_MATERIAL = '/texture/api/v3/create-patterns-material/';
// Requests
export const GET_REQUESTS_API = '/request/api/request-details/';
export const GET_REQUESTS_COUNT_API = '/request/api/request-count/';
export const CHECK_FOR_UNICODE = '';

export const LIGHTING_CONTENT_LIST = '/configurator/api/v2/content-type-list-api/';
export const UPLOAD_MULTIPLE_LIGHTROOM = '/configurator/api/v2/multiple-configurator-lightroom/';

// Optimize APIs - Images
export const OP_GET_RENDER_PREVIEW_API = '/rendering-system/api/v3/get-project-render-images/';
// Optimize APIs - Images Filters
export const GET_IMAGES_SIDEFILTER_COLLECTIONS =
  '/rendering-system/api/v3/sidefilter/get-collections/';
export const GET_IMAGES_SIDEFILTER_BRANDS = '/rendering-system/api/v3/sidefilter/get-brands/';
export const GET_IMAGES_SIDEFILTER_PROPS = '/rendering-system/api/v3/sidefilter/get-props/';
export const GET_IMAGES_SIDEFILTER_LABELS =
  '/rendering-system/api/v3/sidefilter/get-filter-labels/';
export const GET_IMAGES_SIDEFILTER_OPTIONS =
  '/rendering-system/api/v3/sidefilter/get-filter-options/';

// Optimize APIs - Projects
export const OP_GET_PROJECT_API = '/organization/api/v3/get-projects/details/';
// Optimize APIs - Projects Filters
export const GET_PROJECTS_SIDEFILTER_COLLECTIONS =
  '/organization/api/v3/sidefilter/project-collection-filter/';
export const GET_PROJECTS_SIDEFILTER_BRANDS =
  '/organization/api/v3/sidefilter/project-brand-filter/';
export const GET_PROJECTS_SIDEFILTER_PROPS = '/organization/api/v3/sidefilter/get-project-props/';
export const GET_PROJECTS_SIDEFILTER_LABELS =
  '/organization/api/v3/sidefilter/get-project-filter-labels/';
export const GET_PROJECTS_SIDEFILTER_OPTIONS =
  '/organization/api/v3/sidefilter/get-project-filter-options/';

// Optimize APIs - Props & My Props
export const PRODUCT_3D_MODEL_UPLOAD_API = '/assetbundles/api/v3/products/detail/user/upload/';
export const PRODUCT_3D_MODEL_BULK_UPLOAD_API =
  '/assetbundles/api/v3/products/detail/user/bulk-upload/';
export const PRODUCT_3D_MODEL_JOB_API = '/assetbundles/api/v3/products-viewer-job/detail/';
export const OP_GET_PROP_API = '/assetbundles/api/v3/get-products/detail/';
export const OP_GET_PROP_API_V2 = '/assetbundles/api/v3/get-product/detail/';
// Optimize APIs - Props & My Props Filters
export const GET_PROP_SIDEFILTER_COLLECTIONS = '/assetbundles/api/v3/sidefilter/get-collection/';
export const GET_PROP_SIDEFILTER_BRANDS = '/assetbundles/api/v3/sidefilter/get-brands/';
// export const GET_PROP_SIDEFILTER_PROPS = '/organization/api/v3/sidefilter/get-project-props/';
export const GET_PROP_SIDEFILTER_LABELS = '/assetbundles/api/v3/sidefilter/get-filter-label/';
export const GET_PROP_SIDEFILTER_OPTIONS = '/assetbundles/api/v3/sidefilter/get-filter-options/';
export const GET_PDP_PRODUCTS_API = '/subscription/api/pdp-products/';

// Optimize APIs - Templates & My Rooms
export const OP_GET_ROOMS_API = '/rooms/api/v3/get-room-detail/';

export const OP_GET_SORT_ROOMS_API = '/rooms/api/v3/get-room-detail-sort/';
// Optimize APIs - Props & My Props Filters
export const GET_ROOMS_SIDEFILTER_COLLECTIONS = '/rooms/api/v3/sidefilter/get-collection/';
export const GET_ROOMS_SIDEFILTER_BRANDS = '/rooms/api/v3/sidefilter/get-brands/';
// export const GET_ROOMS_SIDEFILTER_PROPS = '/organization/api/v3/sidefilter/get-project-props/';
export const GET_ROOMS_SIDEFILTER_LABELS = '/rooms/api/v3/sidefilter/get-filter-label/';
export const GET_ROOMS_SIDEFILTER_OPTIONS = '/rooms/api/v3/sidefilter/get-filter-options/';

// Optimize APIs - Texture & Custom maps
export const OP_GET_TEXTURES_API = '/texture/api/v3/get-textures-v2-detail/';
// Optimize APIs - Texture & Custom maps
export const GET_TEXTURES_SIDEFILTER_COLLECTIONS = '/texture/api/v3/sidefilter/get-collection/';
// export const GET_TEXTURES_SIDEFILTER_BRANDS = '/rooms/api/v3/sidefilter/get-brands/';
// export const GET_TEXTURES_SIDEFILTER_PROPS = '/organization/api/v3/sidefilter/get-project-props/';
export const GET_TEXTURES_SIDEFILTER_LABELS = '/texture/api/v3/sidefilter/get-filter-label/';
export const GET_TEXTURES_SIDEFILTER_OPTIONS = '/texture/api/v3/sidefilter/get-filter-options/';
export const GET_TUTORIAL_VIDEO = '/video_tutorial/api/client/details/';
export const GET_TUTORIAL_VIDEO_SUB_CATEGORY_OPTION_LIST =
  '/video_tutorial/api/subcategory/details/';

//Assign packs to organization
export const GET_PACK_PRODUCT_LIST = '/subscription/api/pack-info-check/';
export const ASSIGN_PACK_PRODUCT_TO_ORG = '/subscription/api/pack-info-check/';
export const PACK_PRODUCT_FEATURES = '/subscription/api/pack-features/';
export const GET_PURCHASED_PACK_INFO = '/subscription/api/purchase-pack-info/';
export const SUBSCRIPTION_PURCHASED_PACKS = '/subscription/api/all-pack-info/';

// export const GET_PACK_FEATURE= "/subscription/api/pack_feature_public/"

export const GET_PENDING_PACK_REQUESTS = '/subscription/api/pending-pay-as-you-go-requests/';
export const GET_STRIPE_ID_AMOUNT = '/subscription/api/check-price-info/';
export const CRUD_RETAIL_AUTOMATION = '/retail_automation/api/retail-automation/';
export const CRUD_RETAIL_AUTOMATION_SETS = '/retail_automation/api/retail-automation-set/';
export const CRUD_RETAIL_AUTOMATION_HOTSPOT = '/retail_automation/api/retail-hotspot/';
export const CRUD_RETAIL_AUTOMATION_HOTSPOT_PRESIGNED = '/retail_automation/api/retail-hotspot-presigned/';
export const CRUD_RETAIL_AUTOMATION_HOTSPOT_UPDATE = '/retail_automation/api/retail-hotspot-update/';
export const CRUD_RETAIL_AUTOMATION_CAMERA = '/retail_automation/api/hotspot-camera/';
export const CRUD_RETAIL_AUTOMATION_BULK_CAMERA = '/retail_automation/api/multiple-hotspot-camera/';
export const RETAIL_AUTOMATION_PROP_VARIANT = '/assetbundles/api/v3/get-prop-variatns-list/';
export const RETAIL_AUTOMATION_PROP_VARIANT_V2 = '/assetbundles/api/v3/get-prop-small/';
export const RETAIL_AUTOMATION_PROP_VARIANT_LISTING = '/assetbundles/api/v3/get-prop-variants/';
export const CRUD_RETAIL_AUTOMATION_ARTWORK = '/retail_automation/api/art-work/';
export const CRUD_RETAIL_AUTOMATION_ARTWORK_TEXTURE = '/retail_automation/api/art-work-textures/';
export const CRUD_RETAIL_AUTOMATION_PRODUCTS = '/retail_automation/api/hotspot-product/';
export const CRUD_RETAIL_AUTOMATION_PRODUCTS_V2 = '/retail_automation/api/multiple-hotspot-product/';
export const DUPLICATE_ARTWORK = '/retail_automation/api/art-work-duplicate/';
export const RENDER_ARTWORK = '/retail_automation/api/art-work-render/';
export const CREATE_MULTI_TEXTURE_RETAIL_AUTO =
  '/retail_automation/api/multiple-art-work-textures/';
export const DUPLICATE_MULTI_TEXTURE_RETAIL_AUTO =
  '/retail_automation/api/duplicate-multiple-texture/';
export const DUPLICATE_HOTSPOT_PRODUCT = '/retail_automation/api/duplicate-hotspot-product/';
export const PROPS_API_V2 = '/assetbundles/api/v3/homepage/get-products/detail/';

// Imagine AI
export const GET_IMAGINE_AI_API = '/aiimages/api/details/';

// mattress builder api start
export const CRUD_PRODUCT_BUILDER = '/organization/api/v3/product-builder/details/';
export const PRODUCT_BUILDER_PROPS = '/assetbundles/api/v3/product-builder-prop-list/';
export const PRODUCT_BUILDER_PROPERTY = '/product_builder/api/get-product-property-list/';
export const PRODUCT_BUILDER_PROPERTY_IDS = '/product_builder/api/get-product-property-type-list/';
export const PRODUCT_BUILDER_PRODUCT_PRESET = '/product_builder/api/save-product-preset/';
// Product Page revamp
export const GET_MODEL_TEMPLATE = '/rendering-system/api/v3/get-model-template/';
export const AUTOMATION_RENDER_API = '/rendering-system/api/v3/product-page/render-details/';
export const AUTOMATION_RENDER_API_360 = '/rendering-system/api/v3/send-auto-360-viewer-job-v2/';
export const AUTOMATION_RENDER_API_360_TEXTURE =
  '/rendering-system/api/v3/send-auto-texture-360-viewer-job-v2/';
export const PRODUCT_BUILDER_TEXTURES = '/texture/api/v3/mattress/texture/';
export const OPTIMIZED_PRODUCT_GET_API_HOMEPAGE =
  '/assetbundles/api/v3/homepage/get-products/detail/';
export const OP_GET_MATERIAL_API = '/material/api/v3/homepage/material/detail/';
export const GET_MATERIAL_SIDEFILTER_COLLECTIONS = '/material/api/v3/sidefilter/get-collection/';
export const GET_MATERIAL_SIDEFILTER_BRANDS = '/material/api/v3/homepage/sidefilter/get-brands/';
export const GET_MATERIAL_SIDEFILTER_LABELS = '/material/api/v3/sidefilter/get-filter-label/';
export const GET_MATERIAL_SIDEFILTER_OPTIONS = '/material/api/v3/sidefilter/get-filter-options/';
export const GET_PROP_SIDEFILTER_COLLECTIONS_ORGID =
  '/assetbundles/api/v3/sidefilter/:orgId/get-collection/';
export const GET_PROP_SIDEFILTER_BRANDS_ORGID =
  '/assetbundles/api/v3/sidefilter/:orgId/get-brands/';
export const GET_PROP_SIDEFILTER_LABELS_ORGID =
  '/assetbundles/api/v3/sidefilter/:orgId/get-filter-label/';
export const GET_PROP_SIDEFILTER_OPTIONS_ORGID =
  '/assetbundles/api/v3/sidefilter/:orgId/get-filter-options/';

// Optimize APIs - Shared Product Page
export const OP_GET_SHARED_PRODUCT_API =
  '/organization/api/v3/product-page/share-to-organization-listing/';
